import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAcceptConflictBold = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={17}
    height={17}
    viewBox='0 0 17 17'
    fill='none'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M11.15 5.20605C11.4046 4.90907 11.8512 4.87471 12.1482 5.12927C12.4452 5.38385 12.4795 5.83042 12.225 6.12744L7.47762 11.6668L4.81169 9.0009C4.53508 8.72427 4.53507 8.27588 4.81169 7.99927C5.0883 7.72268 5.5367 7.72267 5.81331 7.99927L7.39738 9.58333L11.15 5.20605Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.5 1.41675L14.875 3.54175V8.14592C14.875 9.97995 14.336 11.217 13.2577 12.6678L13.1623 12.7916C12.1407 14.059 10.0704 15.1061 8.5 15.5834C6.87894 15.0907 4.82063 14.1186 3.74227 12.6678C2.66404 11.217 2.125 9.97995 2.125 8.14592V3.54175L8.5 1.41675ZM3.54167 4.56274V8.14592C3.54167 9.60307 3.93405 10.5511 4.87948 11.8232C5.6089 12.8045 7.07834 13.6038 8.49585 14.092C9.10729 13.8758 9.7823 13.5748 10.4064 13.2122C11.1911 12.7562 11.7913 12.2661 12.1205 11.8232C13.0659 10.5511 13.4583 9.60308 13.4583 8.14592V4.56274L8.5 2.9102L3.54167 4.56274Z'
    />
  </svg>
);
export default SvgAcceptConflictBold;
